import type { SchedulingContext } from "@/lib/scheduling/types"
import { atom } from "jotai"

/**
 * Latest scheduling context (§2A.4). `null` until the first read resolves, and
 * whenever the endpoint is unavailable — every consumer degrades to the
 * pre-scheduling behaviour in that case.
 */
export const schedulingContextAtom = atom<SchedulingContext | null>(null)

export default schedulingContextAtom
